import { render, staticRenderFns } from "./PlayerLoader.vue?vue&type=template&id=dc68535e&scoped=true"
import script from "./PlayerLoader.vue?vue&type=script&lang=ts"
export * from "./PlayerLoader.vue?vue&type=script&lang=ts"
import style0 from "./PlayerLoader.vue?vue&type=style&index=0&id=dc68535e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc68535e",
  null
  
)

export default component.exports